import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('@/views/home/index'),

  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index'),
  },
  {
    path: '/basicInfo',
    name: 'basicInfo',
    component: () => import('@/views/basicInfo/index'),
  },
  {
    path: '/emergencyContacts',
    name: 'emergencyContacts',
    component: () => import('@/views/emergencyContacts/index'),
  },
  {
    path: '/KYCProcess',
    name: 'KYCProcess',
    component: () => import('@/views/KYCProcess/index'),
  },
  {
    path: '/historyAppointment',
    name: 'historyAppointment',
    component: () => import('@/views/historyAppointment/index'),
  },
  {
    path: '/delete',
    name: 'delete',
    component: () => import('@/views/delete/index'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/index'),
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('@/views/my/index'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about/index'),

  },
  {
    path: '/extend',
    name: 'extend',
    component: () => import('@/views/extend/index'),

  },
  {
    path: '/repayment',
    name: 'repayment',
    component: () => import('@/views/repayment/index'),

  },
  {
    path: '/entry',
    name: 'entry',
    component: () => import('@/views/entry/index'),
  },
  {
    path: '/myRepayment',
    name: 'myRepayment',
    component: () => import('@/views/myRepayment/index'),
  },
  {
    path: '/pendingRepayment',
    name: 'pendingRepayment',
    component: () => import('@/views/pendingRepayment/index'),
  },
  {
    path: '/loanHistory',
    name: 'loanHistory',
    component: () => import('@/views/loanHistory/index'),
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: () => import('@/views/changePassword/index'),
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('@/views/apply/index'),
  },
  {
    path: '/identity',
    name: 'identity',
    component: () => import('@/views/identity/index'),
  },
  {
    path: '/kycHome',
    name: 'kycHome',
    component: () => import('@/views/kycHome/index'),
  },
  {
    path: '/face',
    name: 'face',
    component: () => import('@/views/face/index'),
  },
  {
    path: '/bank',
    name: 'bank',
    component: () => import('@/views/bank/index'),
  },
  {
    path: '/ifsc',
    name: 'ifsc',
    component: () => import('@/views/ifsc/index'),
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    component: () => import('@/views/confirmation/index'),
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/views/privacyPolicy/index'),
  },
  {
    path: '/coupons',
    name: 'coupons',
    component: () => import('@/views/coupons/index'),
  },
  {
    path: '/cuponDetails',
    name: 'cuponDetails',
    component: () => import('@/views/cuponDetails/index'),
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/agreement/index'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/contact/index'),
  },
  {
    path: '/oneCickApplication',
    name: 'oneCickApplication',
    component: () => import('@/views/oneCickApplication/index'),
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('@/views/details/index'),
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/views/activity/index'),
  },
  {
    path: '/repaymentDetails',
    name: 'repaymentDetails',
    component: () => import('@/views/repaymentDetails/index'),
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/message/index'),
  },
  {
    path: '/messageDetails',
    name: 'messageDetails',
    component: () => import('@/views/messageDetails/index'),
  },
  {
    path: '/addTelegram',
    name: 'addTelegram',
    component: () => import('@/views/addTelegram/index'),
  },
  {
    path: '/loanDisbursementAgreement',
    name: 'loanDisbursementAgreement',
    component: () => import('@/views/loanDisbursementAgreement/index'),
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  let appId = localStorage.getItem("appCode")
  document.title = `${appId}-${to.name}`
  const pageName = to.name;
  window.gtag("event", "page_view", {
    page_title: pageName,
  });
  const enterTime = Date.now();
  to.meta.leaveGuard = router.afterEach((to, from) => {
    const stayTime = Date.now() - enterTime;
    window.gtag("event", "stay_time", {
      value: stayTime,
      event_category: "timing",
      event_label: pageName,
    });
    to.meta.leaveGuard();
  });
  next()

})
export default router
